// Components
import { TranslationService } from '@/utils/services/TranslationService';

// Hooks
import useSocialProfiles from '@/utils/hooks/swr/useSocialProfiles';

//lib
import { REPORT_TYPES } from '@/lib/reports/reportFormTypesConfig';
import { REPORTS_ACCOUNTS } from '@/lib/routes/privateRoutes';

// Layouts
import { WrapperSwitchLayout } from '@/components/layouts/wrappers/WrapperSwitchLayout';
import CreateEditPage from '@/components/pages/reports/CreateEditPage';

const PageContent = () => {
    const { activatedSocialProfiles, mutateSocialProfiles, isLoading, socialProfilesError } =
        useSocialProfiles({
            revalidateOnMount: false
        });
    return (
        <CreateEditPage
            type={REPORT_TYPES.ACCOUNT}
            isLoading={isLoading}
            hasError={!!socialProfilesError}
            contentList={activatedSocialProfiles}
            mutateContent={mutateSocialProfiles}
        />
    );
};

const CreatesReportAccounts = () => {
    return (
        <WrapperSwitchLayout>
            <PageContent />
        </WrapperSwitchLayout>
    );
};

export const getStaticProps = TranslationService.getTranslationMessagesFromRoute(REPORTS_ACCOUNTS);

export default CreatesReportAccounts;
